class HavenFieldStories extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-haven-story-track]');
    this.previous = this.querySelector('[data-haven-story-previous]');
    this.next = this.querySelector('[data-haven-story-next]');
    if (!this.track || !this.previous || !this.next) return;

    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplayDelay = Number.parseInt(this.dataset.autoplayDelay, 10) || 5000;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.handlePrevious = () => this.handleManualNavigation(-1);
    this.handleNext = () => this.handleManualNavigation(1);
    this.handlePause = () => this.stopAutoplay();
    this.handleResume = () => this.startAutoplay();
    this.handleVisibility = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();

    this.previous.addEventListener('click', this.handlePrevious);
    this.next.addEventListener('click', this.handleNext);
    this.addEventListener('mouseenter', this.handlePause);
    this.addEventListener('mouseleave', this.handleResume);
    this.addEventListener('focusin', this.handlePause);
    this.addEventListener('focusout', this.handleResume);
    this.track.addEventListener('pointerdown', this.handlePause, { passive: true });
    this.track.addEventListener('pointerup', this.handleResume, { passive: true });
    document.addEventListener('visibilitychange', this.handleVisibility);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.previous?.removeEventListener('click', this.handlePrevious);
    this.next?.removeEventListener('click', this.handleNext);
    this.removeEventListener('mouseenter', this.handlePause);
    this.removeEventListener('mouseleave', this.handleResume);
    this.removeEventListener('focusin', this.handlePause);
    this.removeEventListener('focusout', this.handleResume);
    this.track?.removeEventListener('pointerdown', this.handlePause);
    this.track?.removeEventListener('pointerup', this.handleResume);
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  handleManualNavigation(direction) {
    this.stopAutoplay();
    this.scrollStories(direction);
    this.startAutoplay();
  }

  scrollStories(direction) {
    const card = this.track.querySelector('.haven-field-stories__card');
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const distance = (card?.getBoundingClientRect().width || this.track.clientWidth * 0.72) + gap;
    const end = this.track.scrollWidth - this.track.clientWidth;

    if (direction > 0 && this.track.scrollLeft >= end - 4) {
      this.track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    if (direction < 0 && this.track.scrollLeft <= 4) {
      this.track.scrollTo({ left: end, behavior: 'smooth' });
      return;
    }

    this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.prefersReducedMotion || document.hidden) return;
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => this.scrollStories(1), this.autoplayDelay);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }
}

if (!customElements.get('haven-field-stories')) {
  customElements.define('haven-field-stories', HavenFieldStories);
}
